import React from 'react';
// import PropTypes from 'prop-types'
import { getFormInputClassNames } from '../sharedFormFunctions';

import './_textArea.scss';

const styles = (cN: string) => {
  const mapped = cN.split(' ');
  return mapped.join(' ');
};

export type ITextArea = {
  id: string;
  labelText?: string;
  height?: string;
  hideLabelText?: boolean;
  value?: string | null | undefined;
  invalid?: boolean;
  invalidText?: string | null | undefined;
  disabled?: boolean;
  placeholder?: string;
  maxLength?: number;
  onChange?: (arg: string) => void;

  onBlur?: (value?: string | null | undefined) => void;
};

const TextArea = React.forwardRef((props: ITextArea, ref: any) => {
  const [length, setLength] = React.useState((props.value || '').length);
  const counterId = `${props.id}__counter`;

  return (
    <label
      htmlFor={props.id}
      className={styles(getFormInputClassNames('c_text-area', props))}
    >
      <span
        className={styles(
          `c_text-area__label-text ${props.hideLabelText && 'u_visuallyhidden'}`
        )}
      >
        {props.labelText}
      </span>
      {props.invalid && (
        <span className={styles('c_text-area__invalid-text')}>
          {props.invalidText}
        </span>
      )}
      <textarea
        name={props.id}
        ref={ref}
        style={props.height ? { minHeight: props.height } : {}}
        defaultValue={props.value || undefined}
        disabled={props.disabled}
        maxLength={props.maxLength}
        aria-describedby={props.maxLength ? counterId : undefined}
        onChange={(e) => {
          setLength(e.target.value.length);
          if (props.onChange) {
            props.onChange(e.target.value);
          }
        }}
        onBlur={(event) => {
          if (props.onBlur) {
            props.onBlur(event.target.value);
          }
        }}
        // onFocus={props.onFocus ? (e) => props.onFocus(e) : null}
        placeholder={props.placeholder || undefined}
      />
      {props.maxLength && (
        <span id={counterId} className={styles('c_text-area__counter')}>
          {length} / {props.maxLength}
        </span>
      )}
    </label>
  );
});

// TextArea.propTypes = {
//   id: PropTypes.string.isRequired,
//   labelText: PropTypes.string.isRequired,
//   hideLabelText: PropTypes.bool,
//   value: PropTypes.string.isRequired,
//   onChange: PropTypes.func.isRequired,
//   onBlur: PropTypes.func,
//   onFocus: PropTypes.func,
//     className: PropTypes.string,  // eslint-disable-line
//   placeholder: PropTypes.string,
//   invalid: PropTypes.bool,
//   invalidText: PropTypes.string
// }

// TextArea.defaultProps = {
//   hideLabelText: false,
//   invalid: false,
//   invalidText: 'Invalid'
// }

export { TextArea };
